import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Select, message } from 'antd'
import './../../ui.style.scss'
import { isIP } from 'is-ip'

class MetaDefaultInput extends React.Component {
  constructor (props) {
    super(props)
    const { value } = this.props
    this.state = {
      selectedItems: props.selectedItems && props.selectedItems.length ? props.selectedItems : [],
      autoFocus: false,
      searchVal: '',
      metaOptions: value || []
    }
  }
    onSearch = (value) => {
      this.lastSearchedValue = value
      this.setState({ searchVal: value })
    }

    onChangeTag = (value) => {
      let isValidIp = true
      value.forEach(ip => {
        const splitIp = (ip).split('/')
        const isIpValid = isIP(splitIp[0])
        let isValidMask = true
        if (splitIp.length > 2) {
          const maskVal = ip.slice(ip.indexOf('/'))
          isValidMask = /^\/{1}[0-9]{1,2}$/.test(maskVal)
        }
        if (!isIpValid || !isValidMask) {
          isValidIp = false
        }
      })
      if (isValidIp) {
        this.setState({ metaOptions: value, searchVal: '' })
        this.props.handleChange(value, this.props.index)
      } else message.warn('Please enter a valid IP')
    }

    componentWillReceiveProps (nextProps) {
      if (!_.isEqual(nextProps.type, this.props.type)) {
        this.setState({ metaOptions: [] })
      }
    }

    render () {
      const {
        placeholder,
        parentCompoent,
        className,
        containerClass,
        disabled,
        mode
      } = this.props
      const { selectedItems, searchVal, metaOptions } = this.state
      const isNotPresent = _.isEmpty((metaOptions || []).find(tag => tag === searchVal))

      return (
        <Select
          key={JSON.stringify(selectedItems)}
          className={`input-tags user-ip-input  ${containerClass}`}
          mode={isNotPresent ? mode : 'multiple'}
          dropdownClassName={`${className || ''}${(searchVal && isNotPresent) ? ' hide-manual-tag-first' : ''}`}
          value={metaOptions || undefined}
          placeholder={placeholder}
          onSearch={this.onSearch}
          onChange={this.onChangeTag}
          getPopupContainer={() => document.getElementById(parentCompoent)}
          filterOption={false}
          disabled={disabled}
        />
      )
    }
}

MetaDefaultInput.propTypes = {
  /** Placeholder text of TagsInput. */
  placeholder: PropTypes.string
}

MetaDefaultInput.defaultProps = {
  selectedItems: [],
  placeholder: 'Select',
  parentCompoent: 'root',
  mode: 'tags'
}

export default MetaDefaultInput
